// Mock data for AgroCorp India website

export const WHATSAPP_BASE = "https://wa.me/919823490072";
export const WHATSAPP_DEFAULT = `${WHATSAPP_BASE}?text=${encodeURIComponent("Hello AgroCorp India, I would like to inquire about your export products.")}`;
export const getWhatsAppLink = (productName) =>
  `${WHATSAPP_BASE}?text=${encodeURIComponent(`Hello AgroCorp India, I would like to inquire about ${productName}.`)}`;

export const products = [
  {
    id: 1,
    name: "Cane Jaggery",
    category: "Jaggery Products",
    image: "https://customer-assets.emergentagent.com/job_b060ace3-0bc6-4db8-bd84-7f92111eacd1/artifacts/q51qazhx_cane%20jaggery.jpeg",
    shortDescription: "Pure, natural cane jaggery produced using traditional methods for worldwide export",
    fullDescription: "Our premium cane jaggery is made from 100% pure sugarcane juice, processed using traditional methods to preserve its natural nutrients and authentic taste. Rich in iron, minerals, and antioxidants, it is the perfect natural sweetener for health-conscious consumers and food manufacturers worldwide. Ideal for bulk export to international markets.",
    features: [
      "100% Natural & Organic",
      "No Chemical Processing",
      "Rich in Iron & Minerals",
      "Traditional Production Method",
      "Export Quality Standards"
    ],
    specifications: {
      "HSN Code": "17011490",
      "Purity": "100% Pure",
      "Color": "Golden Brown",
      "Moisture Content": "Less than 5%",
      "Packaging": "1kg, 5kg, 10kg, 25kg Bulk",
      "Shelf Life": "12 months",
      "Storage": "Store in cool, dry place below 25\u00b0C"
    },
    hsnCode: "17011490",
    seoMeta: {
      title: "Bulk Organic Cane Jaggery Exporter from India | Wholesale Supplier \u2013 Agro Corp India",
      description: "Buy premium organic cane jaggery in bulk from Agro Corp India, Pune. HSN 17011490. Worldwide wholesale export. FSSAI & APEDA certified. Request bulk quote.",
      keywords: "cane jaggery exporter India, organic jaggery wholesale, bulk jaggery supplier Pune, jaggery worldwide export, HSN 17011490, natural sweetener export"
    }
  },
  {
    id: 2,
    name: "Jaggery Powder",
    category: "Jaggery Products",
    image: "https://customer-assets.emergentagent.com/job_b060ace3-0bc6-4db8-bd84-7f92111eacd1/artifacts/qrpl3x34_jaggery%20powder.jpeg",
    shortDescription: "Finely ground jaggery powder for bulk export to food processing industries worldwide",
    fullDescription: "Our jaggery powder is made from premium quality cane jaggery, finely ground to ensure easy dissolution and uniform sweetness. Ideal for tea, coffee, desserts, bakery, and food manufacturing applications. Retains all the natural goodness of traditional jaggery in a convenient powder form. Available for wholesale export to global markets.",
    features: [
      "Fine Texture for Easy Mixing",
      "No Additives or Preservatives",
      "Natural Sweet Flavor",
      "Hygienically Processed & Packed",
      "Ready to Use"
    ],
    specifications: {
      "HSN Code": "17011490",
      "Purity": "100% Pure Jaggery",
      "Mesh Size": "40-60 mesh",
      "Moisture Content": "Less than 3%",
      "Packaging": "500g, 1kg, 5kg, 25kg Bulk",
      "Shelf Life": "10 months",
      "Storage": "Store in cool, dry place away from moisture"
    },
    hsnCode: "17011490",
    seoMeta: {
      title: "Wholesale Jaggery Powder Exporter India | Bulk Supplier \u2013 Agro Corp India",
      description: "Premium jaggery powder for bulk export from India. HSN 17011490. Fine-ground, chemical-free. Worldwide wholesale supplier. FSSAI certified. Inquire now.",
      keywords: "jaggery powder exporter India, bulk jaggery powder supplier, wholesale jaggery powder, jaggery powder global export, HSN 17011490, natural sweetener powder"
    }
  },
  {
    id: 3,
    name: "Onion Powder",
    category: "Dehydrated Products",
    image: "https://customer-assets.emergentagent.com/job_b060ace3-0bc6-4db8-bd84-7f92111eacd1/artifacts/p2nweou6_onion%20powder.jpeg",
    shortDescription: "Premium quality dehydrated onion powder with intense flavor for bulk export",
    fullDescription: "Our onion powder is made from carefully selected fresh onions, dehydrated using advanced technology to preserve flavor, aroma, and nutritional value. Perfect for food processing, instant mixes, seasonings, and culinary applications across global markets. Available in bulk quantities for wholesale export.",
    features: [
      "Made from Fresh Quality Onions",
      "Low Moisture Content",
      "Strong Flavor & Aroma",
      "Hygienically Processed",
      "Food Grade Quality"
    ],
    specifications: {
      "HSN Code": "07129010",
      "Purity": "100% Pure Onion",
      "Moisture": "Less than 5%",
      "Color": "Creamy White",
      "Packaging": "1kg, 5kg, 10kg, 25kg Bulk",
      "Shelf Life": "18 months",
      "Storage": "Store in cool, dry, ventilated area below 25\u00b0C"
    },
    hsnCode: "07129010",
    seoMeta: {
      title: "Bulk Dehydrated Onion Powder Exporter India | Worldwide Wholesale \u2013 Agro Corp India",
      description: "Premium dehydrated onion powder for bulk export from India. HSN 07129010. Strong flavor, low moisture. Worldwide wholesale supplier. Request quote.",
      keywords: "onion powder exporter India, dehydrated onion powder wholesale, bulk onion powder supplier, onion powder worldwide export, HSN 07129010"
    }
  },
  {
    id: 4,
    name: "Moringa Powder",
    category: "Dehydrated Products",
    image: "https://images.unsplash.com/photo-1704079698754-5e621edb610b",
    shortDescription: "Nutrient-rich superfood powder from premium quality moringa leaves for export",
    fullDescription: "Our moringa powder is sourced from carefully selected moringa leaves, dried and ground to preserve maximum nutritional value. Known as a superfood, moringa is rich in vitamins, minerals, and antioxidants. Ideal for health supplements, beverages, and food fortification applications. Available for wholesale export to international markets.",
    features: [
      "100% Natural Moringa Leaves",
      "Rich in Vitamins A, C, E",
      "High Protein Content",
      "No Additives or Preservatives",
      "Certified Organic Available"
    ],
    specifications: {
      "HSN Code": "12119029",
      "Purity": "100% Pure Moringa",
      "Color": "Vibrant Green",
      "Moisture": "Less than 8%",
      "Packaging": "500g, 1kg, 5kg, 25kg Bulk",
      "Shelf Life": "12 months",
      "Storage": "Store in airtight containers away from light and moisture"
    },
    hsnCode: "12119029",
    seoMeta: {
      title: "Organic Moringa Powder Exporter India | Worldwide Bulk Supplier \u2013 Agro Corp India",
      description: "Premium organic moringa powder for wholesale export from India. HSN 12119029. Superfood rich in vitamins. Worldwide bulk supplier. Inquire now.",
      keywords: "moringa powder exporter India, organic moringa wholesale, bulk moringa supplier, moringa powder worldwide export, HSN 12119029, superfood export India"
    }
  },
  {
    id: 5,
    name: "Curry Leaves Powder",
    category: "Dehydrated Products",
    image: "https://customer-assets.emergentagent.com/job_b060ace3-0bc6-4db8-bd84-7f92111eacd1/artifacts/pe6zhvl3_curry%20leaves%20powder.jpeg",
    shortDescription: "Aromatic curry leaves powder with authentic Indian flavor for wholesale export",
    fullDescription: "Our curry leaves powder is made from fresh, aromatic curry leaves that are carefully dried and powdered to retain their distinctive flavor and health benefits. An essential ingredient in Indian cuisine, it adds authentic taste to curries, soups, and various dishes. Available for bulk export to international food manufacturers.",
    features: [
      "Made from Fresh Curry Leaves",
      "Retains Natural Aroma",
      "Rich in Antioxidants",
      "Traditional Processing Method",
      "Export Quality"
    ],
    specifications: {
      "HSN Code": "09109100",
      "Purity": "100% Pure Curry Leaves",
      "Color": "Dark Green",
      "Moisture": "Less than 6%",
      "Packaging": "250g, 500g, 1kg, 5kg, 25kg Bulk",
      "Shelf Life": "12 months",
      "Storage": "Store in cool, dry place in airtight containers"
    },
    hsnCode: "09109100",
    seoMeta: {
      title: "Curry Leaves Powder Exporter India | Bulk Wholesale Supplier \u2013 Agro Corp India",
      description: "Premium dehydrated curry leaves powder for bulk export from India. HSN 09109100. Authentic aroma & flavor. Worldwide wholesale supplier.",
      keywords: "curry leaves powder exporter India, dehydrated curry leaves wholesale, bulk curry powder supplier, HSN 09109100, Indian spice export"
    }
  },
  {
    id: 6,
    name: "Dried Onion Flakes",
    category: "Dehydrated Products",
    image: "https://customer-assets.emergentagent.com/job_b060ace3-0bc6-4db8-bd84-7f92111eacd1/artifacts/6n7n8bit_dried%20onion%20flakes.jpeg",
    shortDescription: "Premium quality dried onion flakes for industrial and worldwide export use",
    fullDescription: "Our dried onion flakes are made from fresh, quality onions that are carefully sliced and dehydrated to preserve flavor and texture. Perfect for instant soups, seasonings, ready-to-eat meals, and food processing applications. Offers convenience without compromising on taste. Available in bulk export quantities for global markets.",
    features: [
      "Made from Fresh White Onions",
      "Quick Rehydration",
      "Consistent Size & Quality",
      "Hygienically Processed",
      "Long Shelf Life"
    ],
    specifications: {
      "HSN Code": "07129010",
      "Purity": "100% Pure Onion",
      "Size": "5-10mm flakes",
      "Moisture": "Less than 5%",
      "Packaging": "1kg, 5kg, 10kg, 25kg Bulk",
      "Shelf Life": "18 months",
      "Storage": "Store in cool, dry, ventilated area below 25\u00b0C"
    },
    hsnCode: "07129010",
    seoMeta: {
      title: "Dried Onion Flakes Exporter India | Bulk Worldwide Wholesale \u2013 Agro Corp India",
      description: "Premium dried onion flakes for bulk export from India. HSN 07129010. Consistent quality, quick rehydration. Worldwide wholesale. Request quote.",
      keywords: "dried onion flakes exporter India, dehydrated onion flakes wholesale, bulk onion flakes supplier, HSN 07129010, onion flakes worldwide export"
    }
  },
  {
    id: 7,
    name: "Premium Basmati Rice",
    category: "Rice & Grains",
    image: "https://images.unsplash.com/photo-1586201375761-83865001e31c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwYmFzbWF0aSUyMHJpY2UlMjBleHBvcnQlMjBwYWNrYWdpbmclMjBncmFpbnxlbnwwfHx8fDE3ODUwODYyMTR8MA&ixlib=rb-4.1.0&q=85",
    shortDescription: "Authentic, long-grain Premium Basmati Rice known for its rich aroma, exquisite taste, and non-sticky texture",
    fullDescription: "Authentic, long-grain Premium Basmati Rice known for its rich aroma, exquisite taste, and non-sticky texture. Sourced from the finest Indian paddy fields and aged to perfection for international culinary standards. Our basmati rice meets the most stringent quality benchmarks for global export markets. Each grain is carefully selected, processed, and aged to deliver consistent quality in every shipment.",
    features: [
      "Extra-Long Grain (8.3mm+ average length)",
      "Naturally Aged for Enhanced Aroma",
      "Non-Sticky, Fluffy Texture After Cooking",
      "100% Pure \u2014 No Blending or Mixing",
      "Meets International Food Safety Standards",
      "Sourced from Premium Indian Paddy Fields",
      "Ideal for Biryani, Pilaf, and Fine Dining"
    ],
    applications: [
      "Hotels, Restaurants & Catering (HoReCa) \u2014 Premium dining and banquet service",
      "Food Service & Institutional \u2014 Airlines, hospitals, corporate catering",
      "Retail Distribution \u2014 Supermarkets and specialty food stores",
      "Food Manufacturing \u2014 Ready meals, frozen meals, and meal kits",
      "Ethnic Grocery Chains \u2014 Indian, Middle Eastern, and Asian food stores"
    ],
    specifications: {
      "HSN Code": "10063020",
      "Grain Type": "Extra-Long Grain Basmati",
      "Average Grain Length": "8.3mm+",
      "Color": "Pearly White / Creamy",
      "Moisture Content": "Max 12.5%",
      "Broken Grains": "Less than 2%",
      "Aroma": "Characteristic Basmati Fragrance",
      "Aging": "Minimum 12 months aged",
      "Origin": "India"
    },
    packagingDetails: [
      "5 kg PP / Non-Woven Bags",
      "10 kg PP / Non-Woven Bags",
      "25 kg PP / Non-Woven Bags",
      "Custom packaging and private labeling available for bulk export orders"
    ],
    shelfLife: "24 Months from date of manufacturing when stored under recommended conditions",
    storageInstructions: [
      "Store in a cool, dry place away from direct sunlight",
      "Keep in airtight containers after opening",
      "Recommended storage temperature: Below 25\u00b0C",
      "Avoid exposure to moisture and pests",
      "Store separately from strong-odor materials"
    ],
    exportDocumentation: [
      "Certificate of Analysis (COA)",
      "Phytosanitary Certificate",
      "FSSAI License Documentation",
      "Certificate of Origin",
      "Commercial Invoice & Packing List",
      "Bill of Lading / Airway Bill",
      "APEDA Registration Certificate",
      "Fumigation Certificate"
    ],
    hsnCode: "10063020",
    seoMeta: {
      title: "Wholesale Premium Basmati Rice Exporter from India | Global Bulk Supplier \u2013 Agro Corp India",
      description: "Premium Basmati Rice exporter from India. HSN 10063020. Extra-long grain, aged, aromatic. Worldwide wholesale bulk supplier. 5kg/10kg/25kg bags. Request quote.",
      keywords: "basmati rice exporter India, wholesale basmati rice supplier, bulk basmati rice worldwide export, HSN 10063020, premium Indian basmati rice, long grain rice wholesale"
    }
  },
  {
    id: 8,
    name: "Fresh Vegetables",
    category: "Fresh Produce",
    image: "https://customer-assets.emergentagent.com/job_b060ace3-0bc6-4db8-bd84-7f92111eacd1/artifacts/u4hctxsy_fresh%20vegetables.jpeg",
    shortDescription: "Farm-fresh vegetables sourced directly from certified farms for worldwide export",
    fullDescription: "We export a wide variety of farm-fresh vegetables including onions, potatoes, tomatoes, cabbage, cauliflower, and more. All vegetables are sourced from certified farms, carefully graded, and packed to ensure maximum freshness during transit to international markets. Available for wholesale export in bulk quantities.",
    features: [
      "Sourced from Certified Farms",
      "Carefully Graded & Selected",
      "Proper Cold Chain Management",
      "Timely Export Documentation",
      "Quality Checked at Multiple Stages"
    ],
    specifications: {
      "HSN Code": "07099990",
      "Quality": "Grade A Export Quality",
      "Storage": "Temperature Controlled 2\u00b0C - 8\u00b0C",
      "Varieties": "Onions, Potatoes, Tomatoes, Leafy Greens",
      "Packaging": "As per buyer requirement",
      "Certification": "FSSAI, APEDA"
    },
    hsnCode: "07099990",
    seoMeta: {
      title: "Fresh Vegetables Exporter India | Worldwide Wholesale Bulk Supply \u2013 Agro Corp India",
      description: "Fresh vegetables for bulk export from India. HSN 07099990. Grade A quality, cold chain managed. Worldwide wholesale supplier. Inquire now.",
      keywords: "fresh vegetables exporter India, wholesale vegetable supplier, bulk vegetables worldwide export, Indian vegetables export, HSN 07099990"
    }
  },
  {
    id: 9,
    name: "Dehydrated Banana Powder",
    category: "Dehydrated Products",
    image: "https://images.unsplash.com/photo-1595414902678-862fe51c9f27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxkZWh5ZHJhdGVkJTIwYmFuYW5hJTIwcG93ZGVyJTIwZm9vZCUyMHByb2R1Y3R8ZW58MHx8fHwxNzc1MzI2ODU2fDA&ixlib=rb-4.1.0&q=85",
    shortDescription: "100% natural dehydrated banana powder for bulk export to food processing industries",
    fullDescription: "Dehydrated Banana Powder is manufactured from carefully selected fresh ripe bananas that undergo a controlled process of cleaning, slicing, dehydration, and fine grinding. The result is a 100% natural, free-flowing powder with no additives, preservatives, or artificial colors. It retains the natural sweetness, aroma, and nutritional profile of fresh bananas, making it an ideal ingredient for a wide range of food processing applications across global markets.",
    features: [
      "100% Natural \u2014 No Additives or Preservatives",
      "Made from Fresh Ripe Indian Bananas",
      "Fine, Free-Flowing Powder Consistency",
      "Retains Natural Sweetness and Aroma",
      "Low Moisture Content for Extended Shelf Life",
      "Hygienically Processed under Strict Quality Controls",
      "Suitable for Organic and Clean-Label Formulations"
    ],
    applications: [
      "Bakery & Confectionery \u2014 Cakes, muffins, cookies, and pastries",
      "Baby Food Manufacturing \u2014 Infant cereals and purees",
      "Health Drinks & Smoothie Mixes \u2014 Nutritional beverages and shake mixes",
      "Instant Food Mixes \u2014 Ready-to-cook and ready-to-eat formulations",
      "Dairy & Ice Cream Industry \u2014 Flavoring for yogurts, ice creams, and milkshakes",
      "Nutraceuticals & Supplements \u2014 Protein bars, energy bars, and dietary supplements",
      "Cereal & Breakfast Foods \u2014 Flavored oats, granola, and muesli"
    ],
    specifications: {
      "HSN Code": "08013200",
      "Product Name": "Dehydrated Banana Powder",
      "Botanical Name": "Musa acuminata",
      "Color": "Light Yellow",
      "Form": "Fine Powder",
      "Moisture Content": "Below 5%",
      "Mesh Size": "80-120 Mesh",
      "Taste & Odor": "Characteristic banana flavor, free from off-odor",
      "Additives": "None",
      "Origin": "India"
    },
    packagingDetails: [
      "10 kg Food-Grade HDPE Bags with Inner Liner",
      "25 kg Food-Grade HDPE Bags with Inner Liner",
      "Custom packaging available as per buyer requirements",
      "All packaging is sealed, tamper-proof, and export-compliant"
    ],
    shelfLife: "12-18 Months from date of manufacturing when stored under recommended conditions",
    storageInstructions: [
      "Store in a cool, dry place away from direct sunlight",
      "Keep in airtight containers after opening",
      "Recommended storage temperature: Below 25\u00b0C",
      "Avoid exposure to moisture and humidity",
      "Do not store near strong-odor materials"
    ],
    exportDocumentation: [
      "Certificate of Analysis (COA)",
      "Phytosanitary Certificate",
      "FSSAI License Documentation",
      "Certificate of Origin",
      "Commercial Invoice & Packing List",
      "Bill of Lading / Airway Bill",
      "APEDA Registration Certificate",
      "Lab Test Reports (Microbiological & Chemical)"
    ],
    hsnCode: "08013200",
    seoMeta: {
      title: "Dehydrated Banana Powder Exporter India | Worldwide Bulk Wholesale \u2013 Agro Corp India",
      description: "Premium dehydrated banana powder for bulk export from India. HSN 08013200. 100% natural, no additives. Worldwide wholesale supplier. Request quote.",
      keywords: "banana powder exporter India, dehydrated banana powder wholesale, bulk banana powder supplier, HSN 08013200, banana powder worldwide export"
    }
  }
];

export const globalRegions = [
  {
    id: 1,
    region: "Middle East & Africa",
    description: "Serving importers and distributors across the Gulf, North Africa, and Sub-Saharan Africa with premium Indian agro products.",
    products: ["Cane Jaggery", "Premium Basmati Rice", "Onion Powder", "Fresh Vegetables"],
    icon: "globe"
  },
  {
    id: 2,
    region: "Europe",
    description: "Exporting to food manufacturers, retailers, and distributors across the European continent with full regulatory compliance.",
    products: ["Jaggery Powder", "Premium Basmati Rice", "Moringa Powder", "Curry Leaves Powder"],
    icon: "globe"
  },
  {
    id: 3,
    region: "Americas",
    description: "Supplying wholesale buyers across North and South America with authentic Indian agricultural products.",
    products: ["Onion Powder", "Moringa Powder", "Dehydrated Banana Powder", "Jaggery Powder"],
    icon: "globe"
  },
  {
    id: 4,
    region: "Asia Pacific",
    description: "Partnering with buyers across South-East Asia, Australia, and the Pacific for premium quality exports.",
    products: ["Premium Basmati Rice", "Dried Onion Flakes", "Fresh Vegetables", "Cane Jaggery"],
    icon: "globe"
  }
];

export const certifications = [
  {
    id: 1,
    name: "FSSAI",
    fullName: "Food Safety and Standards Authority of India",
    description: "Certified for food safety standards",
    logo: "shield"
  },
  {
    id: 2,
    name: "IEC",
    fullName: "Import Export Code",
    description: "Authorized for international trade",
    logo: "globe"
  },
  {
    id: 3,
    name: "APEDA",
    fullName: "Agricultural and Processed Food Products Export Development Authority",
    description: "Registered for agricultural exports",
    logo: "check"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Premium Quality",
    description: "Strict quality control at every stage ensures only the best products reach our customers",
    icon: "award"
  },
  {
    id: 2,
    title: "Hygienic Processing",
    description: "State-of-the-art processing facilities maintaining international hygiene standards",
    icon: "shield-check"
  },
  {
    id: 3,
    title: "Competitive Pricing",
    description: "Direct sourcing and efficient operations enable us to offer the best market prices",
    icon: "dollar-sign"
  },
  {
    id: 4,
    title: "Timely Global Delivery",
    description: "Reliable logistics network ensuring on-time delivery to destinations worldwide",
    icon: "truck"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "International Buyer",
    company: "Global Foods Trading",
    country: "Middle East",
    message: "AgroCorp India has been our trusted supplier. Their jaggery quality is consistently excellent and delivery is always on time.",
    rating: 5
  },
  {
    id: 2,
    name: "International Buyer",
    company: "Natural Foods International",
    country: "Europe",
    message: "Professional service and high-quality products. Their onion powder meets all our specifications perfectly.",
    rating: 5
  }
];

export const contactInfo = {
  companyName: "Agro Corp India",
  address: "At Post Yewat, Tal - Daund, Dist - Pune 412214",
  email: "info@agrocorpindia.com",
  phone: "+91 9637471766",
  phone2: "+91 9699703029",
  whatsapp: "919823490072",
  socialMedia: {
    linkedin: "https://www.linkedin.com/in/agrocorp-india-0462783a3",
    instagram: "https://www.instagram.com/agrocorp_india_",
    facebook: "https://www.facebook.com/share/1D71AM34P9/"
  }
};

export const facilities = [
  {
    id: 1,
    icon: 'Factory',
    title: 'Partner Processing Units',
    description: 'We collaborate with certified processing facilities equipped with modern technology for efficient production while maintaining hygiene standards.',
    features: [
      'Certified partner facilities',
      'Climate-controlled environment',
      'Regular quality audits',
      'ISO-compliant operations'
    ]
  },
  {
    id: 2,
    icon: 'Package',
    title: 'Quality Control Labs',
    description: 'Partner laboratories with advanced testing equipment to ensure every batch meets quality specifications before shipment.',
    features: [
      'Physical and chemical testing',
      'Microbiological analysis',
      'Moisture and purity testing',
      'Certified quality analysts'
    ]
  },
  {
    id: 3,
    icon: 'ThermometerSnowflake',
    title: 'Cold Storage Facilities',
    description: 'Temperature-controlled storage warehouses managed by our partners to preserve freshness and quality of products throughout the supply chain.',
    features: [
      'Multi-temperature zones',
      '24/7 temperature monitoring',
      'Backup power systems',
      'Professional facility management'
    ]
  },
  {
    id: 4,
    icon: 'Truck',
    title: 'Logistics & Warehousing',
    description: 'Efficient logistics network through partner warehouses for seamless inventory management and timely deliveries.',
    features: [
      'Integrated warehouse management',
      'Real-time inventory tracking',
      'Strategic location near ports',
      'Tie-ups with reliable transporters'
    ]
  },
  {
    id: 5,
    icon: 'Shield',
    title: 'Hygienic Processing',
    description: 'All partner facilities follow strict hygiene protocols and sanitization procedures to ensure food safety throughout the production process.',
    features: [
      'HACCP compliance',
      'Regular sanitation schedules',
      'Pest control measures',
      'Staff hygiene training'
    ]
  },
  {
    id: 6,
    icon: 'Users',
    title: 'Skilled Workforce',
    description: 'Working with trained and experienced teams at partner facilities committed to maintaining quality standards and operational excellence.',
    features: [
      'Experienced professionals',
      'Regular training programs',
      'Safety-first culture',
      'Quality-focused mindset'
    ]
  }
];

export const exportTerms = {
  qualityAssurance: [
    "All products undergo stringent quality checks before dispatch",
    "Every shipment accompanied by Certificate of Analysis (COA)",
    "Products comply with FSSAI, APEDA, and international food safety regulations",
    "Third-party lab testing available on request",
    "Batch-wise traceability from farm to shipment"
  ],
  shippingLogistics: [
    "Reliable global delivery via sea and air freight",
    "Shipment within 7\u201315 working days from order confirmation",
    "Full Container Load (FCL) and Less-than-Container Load (LCL) options",
    "Partnered with reputed freight forwarders and shipping lines",
    "Customized packaging options (5kg, 10kg, 25kg PP / Non-Woven bags)",
    "Private labeling and custom branding available for bulk export orders"
  ],
  documentation: [
    "Commercial Invoice & Packing List",
    "Bill of Lading / Airway Bill",
    "Certificate of Origin",
    "Phytosanitary Certificate",
    "Fumigation Certificate (where applicable)",
    "FSSAI & APEDA Registration Certificates",
    "Custom documentation as per buyer or destination country requirements"
  ],
  minimumOrder: "Minimum Order Quantity (MOQ) varies by product. Contact us for specific MOQ details."
};
